/** Stable browser id for trusted-device MFA skip (X-Device-Token). Not an auth credential. */
const STORAGE_KEY = "sl_device_token";

function randomToken(): string {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  const bytes = new Uint8Array(16);
  if (typeof crypto !== "undefined" && typeof crypto.getRandomValues === "function") {
    crypto.getRandomValues(bytes);
  } else {
    for (let i = 0; i < bytes.length; i++) bytes[i] = Math.floor(Math.random() * 256);
  }
  return Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
}

export function getOrCreateDeviceToken(): string {
  try {
    const existing = window.localStorage.getItem(STORAGE_KEY);
    if (existing && existing.length >= 16) {
      return existing;
    }
    const created = randomToken();
    window.localStorage.setItem(STORAGE_KEY, created);
    return created;
  } catch {
    return randomToken();
  }
}

export default { getOrCreateDeviceToken };
